var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { color, alignItems, borderBottom, borderColor, display, flexDirection, flexWrap, justifyContent, space, themeGet, } from 'styled-system';
import { useLocalization } from '../../common/providers/LocaleProvider';
import { getCMSTrackerProps } from '../../common/tracking/getTrackerProps';
import { Text } from '../../common/components/Text';
import { linkStyles } from '../../common/components/Link';
import { FlexJustifyContent, Grid, GridItem, } from '../../common/components/Grid';
import EmailField from './EmailField';
import { Locale } from '../../common/enums/Locale';
var NewsletterSignupGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), color, justifyContent);
NewsletterSignupGrid.defaultProps = {
    bg: 'gray.2',
    mb: ['sp_16', 'sp_24', null, 'sp_32'],
    justifyContent: FlexJustifyContent.CENTER,
};
var NewsletterSignupContainer = styled(GridItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"])), display, flexDirection, flexWrap, justifyContent, alignItems);
NewsletterSignupContainer.defaultProps = {
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    flexWrap: ['auto', 'nowrap'],
    justifyContent: ['auto', 'space-between'],
    alignItems: 'center',
    py: ['22px', 'sp_24', null, 'sp_32'],
    px: ['14px', 'sp_12', 'sp_0'],
    w: 1,
};
var VoucherContainerGrid = styled(GridItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems);
VoucherContainerGrid.defaultProps = {
    w: [1, null, 7 / 12],
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
};
var Voucher = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"])), display, flexDirection, alignItems, borderBottom, borderColor, space);
Voucher.defaultProps = {
    display: ['none', null, 'flex'],
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '2px solid',
    borderColor: 'brand.normal',
    mr: ['sp_0', 'sp_24'],
    mb: ['sp_24', null, 'sp_0'],
};
var CommonText = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
CommonText.defaultProps = {
    as: 'p',
    color: 'gray.16',
    fontSize: 'fs_18',
    fontWeight: 'bold',
    lineHeight: '26px',
    textAlign: 'center',
    mt: 'sp_0',
    mb: 'sp_0',
};
var Amount = styled(CommonText)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  & > span {\n    font-size: 36px;\n  }\n"], ["\n  & > span {\n    font-size: 36px;\n  }\n"])));
var Label = styled(CommonText)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"], ["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"])));
Label.defaultProps = __assign(__assign({}, CommonText.defaultProps), { fontSize: ['fs_18', null, '22px', '26px'], lineHeight: ['lh_28', null, null, 'lh_32'], fontWeight: 600 });
var InputContainerGrid = styled(GridItem)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems);
InputContainerGrid.defaultProps = {
    w: [1, 6 / 8, 5 / 12],
    pt: ['sp_8', null, 'sp_0'],
    pr: ['sp_8', 'sp_12', 'sp_0'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};
var TextContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"])));
var Message = styled(CommonText)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  & > a {\n    ", ";\n    color: ", ";\n  }\n"], ["\n  & > a {\n    ",
    ";\n    color: ", ";\n  }\n"])), function (props) {
    return linkStyles(__assign({ styled: true, textDecoration: 'underline' }, props));
}, themeGet('colors.gray.9'));
Message.defaultProps = __assign(__assign({}, CommonText.defaultProps), { color: 'gray.9', fontSize: ['fs_16', null, null, 'fs_18'], lineHeight: 3, fontWeight: 'normal' });
var Disclaimer = styled(CommonText)(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""])));
Disclaimer.defaultProps = __assign(__assign({}, CommonText.defaultProps), { color: 'gray.9', fontSize: ['fs_16', 'fs_14', null, 'fs_16'], fontWeight: 'normal' });
export var NewsletterSignup = function (_a) {
    var _b = _a.voucher, amount = _b.amount, currency = _b.currency, label = _b.label, headline = _a.headline, tracking = _a.tracking, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    var _c = useLocalization(), r = _c.r, t = _c.t, locale = _c.locale, prefix = _c.prefix;
    var htmlMessage = r(t('h24_newsletter_message'), {
        h24_newsletter_message_link: t('h24_newsletter_message_link'),
        h24_newsletter_message_link_url: prefix.t('h24_newsletter_message_link_url'),
    });
    var isCountryWithCurrencyFirst = [Locale.Nl_Be, Locale.Nl_Nl].includes(locale);
    return (React.createElement(NewsletterSignupGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
        React.createElement(NewsletterSignupContainer, null,
            React.createElement(VoucherContainerGrid, null,
                React.createElement(Voucher, null,
                    isCountryWithCurrencyFirst ? (React.createElement(Amount, null,
                        currency,
                        " ",
                        React.createElement("span", null, amount))) : (React.createElement(Amount, null,
                        React.createElement("span", null, amount),
                        " ",
                        currency)),
                    React.createElement(Label, null, label)),
                React.createElement(TextContainer, null,
                    React.createElement(CommonText, null, headline),
                    React.createElement(Message, __assign({}, getCMSTrackerProps({
                        dangerouslySetInnerHTML: { __html: htmlMessage },
                    }, {
                        event: 'footerTracking',
                        eventData: {
                            placement: 'newsletterSignup',
                            labelIdentifier: 'h24_newsletter_message_link',
                        },
                    }, ['A']))),
                    React.createElement(Disclaimer, { dangerouslySetInnerHTML: {
                            __html: t('h24_newsletter_voucher_disclaimer'),
                        } }))),
            React.createElement(InputContainerGrid, null,
                React.createElement(EmailField, { tracking: tracking })))));
};
NewsletterSignup.defaultProps = {
    voucher: {
        amount: '20',
        currency: '€',
        label: 'Gutschein',
    },
    headline: 'Jetzt 20 € Gutschein sichern',
    __legacy_shop_reboot_max_width: true,
};
export default NewsletterSignup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
